import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb2fc1e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employee-wrapper" }
const _hoisted_2 = { class: "register-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"padding-bottom":"24px"}
}
const _hoisted_4 = { class: "help-file-wrapper" }
const _hoisted_5 = { style: {"margin":"24px auto 17px"} }
const _hoisted_6 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_7 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_8 = { class: "content-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"30px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_12 = {
  key: 2,
  class: "flow-box"
}

import {
  onMounted,
  ref,
  reactive,
  computed,
  withDefaults,
  watch,
  createVNode,
  watchEffect,
} from "vue";
import { USERLIST, BOOKLIST } from "@/const/home";

import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import Approval from "@/components/Approval.vue";

import ButtonGroup from "@/components/ButtonGroup.vue";
import Transfer from "./Detail/Transfer1.vue";

import { DeleteOutlined, PlusSquareOutlined } from "@ant-design/icons-vue";
import { FileType, NodeItem } from "@/types/procss";
import Image from "@/components/Image.vue";
import type { FormInstance } from "ant-design-vue";
import { message, Modal } from "ant-design-vue";
import {
  getEmployeeTransferApply, //获取员工调动申请
  startEmployeeTransferApply, // 提交员工调动
  getBusinessApplyFirstInfo, //获取客户及人选转移
  startCustomerTransferApply, //提交客户及人选
} from "@/api/process_employeeTransfer";
import { GetFilterRegions, GetFilterStaff } from "@/api/api";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { GetCurrentMyPageList } from "@/api/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const currentStep = ref<number>(0);
const visible = ref<boolean>(false);
const route = useRoute();
const { query } = route;
const id = ref(query.id || "");
const WorkFlowId = ref<number>(0);
const firstIn = ref<boolean>(true);

const actionButtons = ref<(string | number)[]>([]); //默认是申请审批

const edit = computed(() => actionButtons.value.includes("100"));
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);

const update = ref<boolean>(false);

const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const refresh = ref<boolean>(false);
watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;

      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value = currentData.value?.Code == "701" ? 0 : 1;
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "7");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value = currentData.value?.Code == "701" ? 0 : 1;
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);

const allStaff = ref<
  {
    value: string;
    label: string;
  }[]
>([]);
const allRegions = ref<
  {
    value: string;
    label: string;
  }[]
>([]);
const form = ref([
  {
    RegionID: undefined,
    RegionName: undefined,
    TransferStaffID: undefined,
    TransferStaffName: undefined,
    SignInLastDate: "",
  },
]);
let form2 = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});
const formRef1 = ref<FormInstance>(); //选址表单
const formRef2 = ref<FormInstance>(); //选址表单
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);

const handleAddClick = () => {
  form.value.push({
    RegionID: undefined,
    RegionName: undefined,
    TransferStaffID: undefined,
    TransferStaffName: undefined,
    SignInLastDate: "",
  });
};

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});

// 获取所有职员
const getStaff = async (val: string) => {
  allStaff.value = [];
  const { Data, Success, Message } = await GetFilterStaff({
    SearchWords: val,
  });
  if (Success) {
    Data.forEach((r: any) => {
      allStaff.value.push({
        value: r.Val,
        label: r.Key,
      });
    });
  }
};

const handleDeleteClick = (index: number) => {
  if (form.value.length < 2) {
    message.error("至少保留一项");
    return;
  }
  form.value.splice(index, 1);
};

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "客户运营篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2024/202406/20240625/20240625_154427106522142_客户运营篇.pdf",
  },
  {
    title: "集团人力篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184438187882144_集团人力篇.pdf",
  },
];

const tableData = [
  {
    depart: "人力发展中心",
    name: "李慧",
    duty: "开设系统账号审批、员工调动审批",
    email: "lihui1@risfond.com",
    phone: "18612393319",
  },
  {
    depart: "客户运营中心",
    name: "赵振兴",
    duty: "客户及人选交接问题",
    email: "ash.zhao@risfond.com",
    phone: "13810621126",
  },
];
const list = ["员工调动申请", "客户及人选转移申请"];

// 获取所有归属大区
const getRegions = async (val: string) => {
  allRegions.value = [];
  const { Data, Success, Message } = await GetFilterRegions({
    KeyWord: val,
  });
  if (Success) {
    Data.forEach((r: any) => {
      allRegions.value.push({
        value: r.Val,
        label: r.Key,
      });
    });
  } else {
    message.warning(Message);
  }
};

const handleChange = (val: string) => {
  const _item = allRegions.value.find((item) => item.value == val);
  const _list = form.value;
  form.value = _list.map((item) => {
    return {
      ...item,
      RegionName: _item?.label,
      RegionID: val,
    };
  });
};

const handleStaffChange = (val: string, index: number) => {
  const _item = allStaff.value.find((item) => item.value == val);
  form.value[index].TransferStaffID = val || "";
  form.value[index].TransferStaffName = _item?.label || "";
};

const submit1 = async () => {
  formRef1.value?.validateFields().then(async (res) => {
    if (form.value.length > 0) {
      form.value = form.value.map((item) => {
        return {
          ...item,
          RegionName: form.value[0]?.RegionName,
          RegionID: form.value[0]?.RegionID,
        };
      });
    }

    //提交申请
    const { Success, Message } = await startEmployeeTransferApply({
      PageData: form.value,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      update.value = !update.value;
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const submit2 = async () => {
  formRef2.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await startCustomerTransferApply({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageFiles: form2.value.PageFiles,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      update.value = !update.value;
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    if (currentStep.value == 0) {
      submit1();
    } else if (currentStep.value == 1) {
      submit2();
    }
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "101") {
    visible.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    //通过
    applyOnOkVisible.value = true;
  } else if (buttonType == "-1") {
    reEdit.value = false;
    handleTabChange(currentStep.value);
    //节点
  } else if (buttonType == "-2") {
    if (currentStep.value == 0) {
      submit1();
    } else if (currentStep.value == 1) {
      submit2();
    }
  }
};

//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (currentStep.value == 1) {
      form2.value.PageFiles = {};
    }
  } else {
    if (currentStep.value == 1) {
      form2.value.PageFiles = [
        {
          ...file,
          FileUrl: file.Url,
        },
      ];
    }
  }
};

//获取员工调动申请
const employeeTransferApply = async () => {
  const { Data } = await getEmployeeTransferApply({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  if (Data?.PageData.length > 0) {
    form.value = Data?.PageData || [];
  }
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId || 0;
};
//获取客户及人选转移
const businessApplyFirstInfo = async () => {
  const { Data } = await getBusinessApplyFirstInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  if (Data?.PageFiles?.length > 0) {
    form2.value.PageFiles = Data?.PageFiles || [];
  }
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId || 0;
};
const handleTabChange = async (index: number) => {
  reEdit.value = false;
  if (index == 0) {
    BranchCompanyFlowId.value = filterCompanyCode("701");
    employeeTransferApply();
  } else if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("702");
    businessApplyFirstInfo();
  }
};
const filterCompanyCode = (code: string) => {
  WorkFlowId.value = 0;
  const { type, id } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    preData.value = props.flowData.find(
      (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
    );
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};
const handleRejectback = () => {
  rejectedVisible.value = false;
  if (refresh.value) {
    refresh.value = false;
  } else {
    refresh.value = true;
  }
  $emit("update-flow");
  getList();
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_RecallBack = _resolveComponent("RecallBack")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "员工调动、客户及人员转移申请注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createVNode(_component_a_steps, {
                class: "common-steps",
                onChange: handleTabChange,
                current: currentStep.value,
                "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((currentStep).value = $event)),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_step, {
                    title: "员工调动申请",
                    status: currentStep.value == 0 ? 'process' : 'wait'
                  }, null, 8, ["status"]),
                  _createVNode(_component_a_step, {
                    title: "客户及人选转移申请",
                    status: currentStep.value == 1 ? 'process' : 'wait'
                  }, null, 8, ["status"])
                ]),
                _: 1
              }, 8, ["current"]),
              _createElementVNode("div", _hoisted_8, [
                (currentStep.value == 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (
                (id.value && _unref(personInfo).IsCreate == 0 && form.value.length == 0) ||
                WorkFlowId.value == 0 ||
                reEdit.value
              )
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            class: "bank-registration-form-wrapper",
                            layout: "inline",
                            "label-col": { style: { width: '100px' } },
                            labelAlign: "left",
                            model: form.value,
                            ref_key: "formRef1",
                            ref: formRef1
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "所属大区",
                                class: "register-form-item",
                                name: [0, 'RegionName'],
                                required: "",
                                colon: false,
                                style: {"margin-right":"300px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: (form.value.length > 0 && form.value[0].RegionName) || '',
                                    "show-search": "",
                                    placeholder: "请输入所属大区",
                                    "default-active-first-option": false,
                                    "show-arrow": false,
                                    "filter-option": false,
                                    "not-found-content": null,
                                    options: allRegions.value,
                                    onSearch: getRegions,
                                    onChange: handleChange
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (member, index) => {
                                return (_openBlock(), _createBlock(_component_a_space, {
                                  key: member.TransferStaffID,
                                  style: {"display":"flex","margin-bottom":"8px"},
                                  align: "baseline"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "调动人员",
                                      class: "register-form-item",
                                      name: [index, 'TransferStaffName'],
                                      required: "",
                                      colon: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: member.TransferStaffName,
                                          "onUpdate:value": ($event: any) => ((member.TransferStaffName) = $event),
                                          "show-search": "",
                                          placeholder: "请输入",
                                          "default-active-first-option": false,
                                          "show-arrow": false,
                                          "filter-option": false,
                                          "not-found-content": null,
                                          options: allStaff.value,
                                          onSearch: getStaff,
                                          onChange: (val) =>handleStaffChange(val, index)
                                        }, null, 8, ["value", "onUpdate:value", "options", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]),
                                    _hoisted_9,
                                    _createVNode(_component_a_form_item, {
                                      label: "考勤截止日期",
                                      class: "register-form-item",
                                      name: [index, 'SignInLastDate'],
                                      required: "",
                                      colon: false,
                                      "label-col": { style: { width: '110px' } }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_date_picker, {
                                          value: form.value[index].SignInLastDate,
                                          "onUpdate:value": ($event: any) => ((form.value[index].SignInLastDate) = $event),
                                          style: {"width":"300px"},
                                          valueFormat: "YYYY-MM-DD",
                                          placeholder: "请选择",
                                          showToday: true
                                        }, null, 8, ["value", "onUpdate:value"])
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]),
                                    (index == form.value.length - 1)
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 0,
                                          type: "link",
                                          danger: "",
                                          size: "small",
                                          style: {"padding-left":"0"},
                                          onClick: ($event: any) => (handleDeleteClick(index))
                                        }, {
                                          icon: _withCtx(() => [
                                            _createVNode(_unref(DeleteOutlined))
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_10
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_a_button, {
                                type: "link",
                                size: "small",
                                style: {"margin-top":"-10px","margin-bottom":"24px"},
                                onClick: handleAddClick
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(PlusSquareOutlined))
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : (_openBlock(), _createBlock(Transfer, {
                            key: 1,
                            "folw-id": BranchCompanyFlowId.value,
                            detail: form.value
                          }, null, 8, ["folw-id", "detail"]))
                    ], 64))
                  : _createCommentVNode("", true),
                (currentStep.value == 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              )
                    }, [
                      _createVNode(_component_a_form, {
                        class: "bank-upload-form-wrapper",
                        layout: "vertical",
                        validateTrigger: "blur",
                        model: _unref(form2),
                        ref_key: "formRef2",
                        ref: formRef2
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            required: "",
                            name: ['PageFiles', 0, 'FileUrl'],
                            label: "客户及人选流程交接表"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                      _unref(form2).PageFiles && _unref(form2).PageFiles.length > 0
                        ? _unref(form2).PageFiles[0].FileUrl
                        : ''
                    ,
                                "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                disable: !!preData.value,
                                onUpload: _cache[1] || (_cache[1] = (file) => handleUpload(file, 0)),
                                "file-type": '721',
                                "download-link": {
                      filename: '客户及人选流程交接表.xlsx',
                      fileKey: '7021',
                    }
                              }, null, 8, ["value", "disable-close", "disable", "download-link"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode(_component_RecallBack, {
                  id: BranchCompanyFlowId.value,
                  show: visible.value,
                  onClose: _cache[2] || (_cache[2] = ($event: any) => {
              visible.value = !visible.value;
              handleTabChange(currentStep.value);
            })
                }, null, 8, ["id", "show"]),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        id: WorkFlowId.value,
                        refresh: refresh.value
                      }, null, 8, ["id", "refresh"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (actionButtons.value.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": actionButtons.value,
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})